export default __webpack_public_path__ + "static/media/logoEmporio2.b8131d8b.png";